// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.objective-type {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.objective-type h3 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}
.objective-type p {
  margin: 0.5rem 0;
  color: #4a5568;
  line-height: 1.5;
}
.objective-type em {
  color: #718096;
  font-style: italic;
}

strong {
  color: #2d3748;
  font-size: 1.2rem;
  margin-bottom: 1rem;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/objective-client/objective-type-tooltip-modal/objective-type-tooltip-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;AACF;AACE;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AACJ;AAEE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;;AAKA;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAFF","sourcesContent":[".objective-type {\r\n  margin-bottom: 1.5rem;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  background-color: #f8f9fa;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n\r\n  h3 {\r\n    color: #2c3e50;\r\n    margin-bottom: 0.5rem;\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  p {\r\n    margin: 0.5rem 0;\r\n    color: #4a5568;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  em {\r\n    color: #718096;\r\n    font-style: italic;\r\n  }\r\n}\r\n\r\nstrong {\r\n  color: #2d3748;\r\n  font-size: 1.2rem;\r\n  margin-bottom: 1rem;\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
